<template>
  <div class="relative">
    <!---Title-->
    <div class="title">
      <h1>Listado de envíos</h1>
      <div class="toolbar">
        <!---Export-->
        <button @click="exportToExcel" class="btn btn--outline">Exportar</button>
        <!---End--->
        <!---Export-->
        <button @click="printLabels" class="btn btn--outline">Imprimir</button>
        <!---End--->
        <!--Filter by date-->
        <div class="space-x-4">
          <span
            @click="currentDateFilter = 'today'"
            class="text-xs px-4 py-2 rounded cursor-pointer"
            :class=" {
              'bg-secondary text-white border-none': currentDateFilter === 'today',
              'text-gray-900 border border-solid border-gray-900': currentDateFilter !== 'today'
            }">Pedidos que se entregan hoy</span>
          <span
            @click="currentDateFilter = 'tomorrow'"
            class="text-xs px-4 py-2 rounded cursor-pointer"
            :class=" {
              'bg-secondary text-white border-none': currentDateFilter === 'tomorrow',
              'text-gray-900 border border-solid border-gray-900': currentDateFilter !== 'tomorrow'
            }">Pedidos que se entregan mañana</span>
        </div>
        <!--End-->
        <!---Search-->
        <div @focusout="showSearch = false" @click="showSearch = true" class="search">
          <svg class="search__icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
               fill="none"
               stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="11" cy="11" r="8"></circle>
            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
          </svg>
          <input id="search"
                 name="search"
                 @focusout="showSearch = false"
                 v-model="search"
                 class="input"
                 :class=" {'show': showSearch}" type="text"
                 placeholder="Buscar por nombre">
        </div>
        <!--End-->
      </div>
    </div>
    <!---End-->
    <!--Table-->
    <div class="max-w-full overflow-auto">
      <!--Header-->
      <div class="table">
        <div class="table__header table__header--history">
          <div><span>Evidencia</span></div>
          <div><span>Cód. tracking</span></div>
          <div><span>Estado</span></div>
          <div><span>Fecha de recojo</span></div>
          <div><span>Fecha de entrega</span></div>
          <div><span>Tipo de servicio</span></div>
          <div><span>Local de recojo</span></div>
          <div><span>Dirección</span></div>
          <div><span>Referencia</span></div>
          <div><span>Distrito</span></div>
          <div><span>Nombre de cliente</span></div>
          <div><span>Teléfono</span></div>
          <div><span>Costo de envío</span></div>
          <div><span>Producto</span></div>
          <div><span>Cantidad</span></div>
          <div><span>Total a cobrar</span></div>
          <div><span>Notas de entrega</span></div>
          <div><span>Comentarios</span></div>
          <div><span>Motorizado</span></div>
        </div>
        <div class="table__content">
          <div v-for="(o, index) in filteredList"
               :key="index"
               class="row row--history">
            <div class="row__item">
              <span class="name">EVIDENCIA</span>
              <div v-if="o.dealer && o.dealer.deliveryImages && o.dealer.deliveryImages.length" class="flex gap-2 flex-wrap">
                <a v-for="(img, i) in o.dealer.deliveryImages" :key="i" class="flex gap-1 block" :href="img" target="_blank">
                  <span>Foto {{ i + 1 }}</span>
                  <link-icon></link-icon>
                </a>
              </div>
              <a v-else-if="o.dealer && o.dealer.deliveryImage" class="flex gap-2" :href="o.dealer.deliveryImage" target="_blank">
                <span>Ver</span>
                <link-icon></link-icon>
              </a>
              <span v-else>Pendiente</span>
            </div>
            <div class="row__item">
              <span class="name">COD. TRACKING</span>
              <input v-model="o.correlative" class="input" type="text" id="correlative" name="correlative" disabled>
            </div>
            <div class="row__item">
              <span class="name">ESTADO</span>
              <span class="inline-block px-2 py-2 rounded-full text-[10px] text-white"
                :class="{
                  'bg-gray-400': o.status === 'hold',
                  'bg-green-600': o.status === 'done',
                  'bg-red-600': o.status !== 'hold' && o.status !== 'done'
                }">{{getStatusText(o.status)}}</span>
            </div>
            <div class="row__item">
              <span class="name">FECHA DE RECOJO</span>
              <input v-model="o.pickUpDate" class="input" type="date" id="pickUpDate" name="pickUpDate" disabled>
            </div>
            <div class="row__item">
              <span class="name">FECHA DE ENTREGA</span>
              <input v-model="o.deadline" class="input" type="date" id="deadline" name="deadline">
            </div>
            <div class="row__item">
              <span class="name">TIPO DE SERVICIO</span>
              <span class="inline-block px-2 py-2 bg-white rounded-full text-xs">{{o.type.label}}</span>
            </div>
            <div class="row__item">
              <span class="name">LOCAL DE RECOJO</span>
              <input v-model="o.pickupAddress" class="input" type="text" id="pickupAddress" name="pickupAddress" disabled>
            </div>
            <div class="row__item">
              <span class="name">DIRECCIÓN</span>
              <input v-model="o.address" class="input" type="text" id="address" name="address" disabled>
            </div>
            <div class="row__item">
              <span class="name">REFERENCIA</span>
              <input v-model="o.reference" class="input" type="text" id="reference" name="reference" disabled>
            </div>
            <div class="row__item">
              <span class="name">DISTRITO</span>
              <select v-model="o.district" class="select" name="district" id="district" disabled>
                <option v-for="(e, index) in districts" :value="e" :key="index">{{ e.label }}</option>
              </select>
            </div>
            <div class="row__item">
              <span class="name">CLIENTE</span>
              <input v-model="o.fullName" class="input" type="text" id="fullName" name="fullName" disabled>
            </div>
            <div class="row__item">
              <span class="name">CELULAR</span>
              <input v-model="o.phone" class="input" type="text" id="phone" name="phone" disabled>
            </div>
            <div class="row__item">
              <span class="name">COSTO DE ENVÍO</span>
              <input :value="o.district.price + o.type.price" class="input" type="text" disabled id="price"
                     name="price">
            </div>
            <div class="row__item">
              <span class="name">PRODUCTO</span>
              <input v-model="o.product" class="input" type="text" id="product" name="product" disabled>
            </div>
            <div class="row__item">
              <span class="name">CANTIDAD</span>
              <input v-model="o.quantity" class="input" type="number" id="quantity" name="quantity" disabled>
            </div>
            <div class="row__item">
              <span class="name">TOTAL A COBRAR</span>
              <input v-model="o.totalToBeCollected" class="input" type="number" id="totalToBeCollected"
                     name="totalToBeCollected" disabled>
            </div>
            <div class="row__item">
              <span class="name">NOTAS DE ENTREGA</span>
              <input v-model="o.notes" class="input" type="text" id="notes"
                     name="notes" disabled>
            </div>
            <div class="row__item">
              <span class="name">COMENTARIOS</span>
               <input v-if="o.dealer" v-model="o.dealer.comments" class="input" type="text" id="comments"
                     name="comments" disabled>
            </div>
            <div class="row__item">
              <span class="name">MOTORIZADO</span>
              <span>{{ o.dealer ? o.dealer.dealerName : 'Sin asignar' }}</span>
            </div>
          </div>
        </div>
      </div>
      <!--End-->
    </div>
    <!---End--->

    <!--Filter-->
    <div class="filter">
      <div class="filter__trigger" @click="showFilter = !showFilter">
        <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Filtrar</title>
          <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"
                d="M32 144h448M112 256h288M208 368h96"/>
        </svg>
      </div>
      <div id="filterContent" class="filter__content" :class=" {'block opacity-100': showFilter}">
        <!--Deadline-->
        <div class="form-group mb-4">
          <label for="deadline">Filtrar por fecha</label>
          <v-date-picker
            id="deadline"
            name="deadline"
            v-model="filterData.deadline"
            :dot="true"
            color="red"
            is-expanded
            is-range
            :timezone="`America/Lima`"
          />
        </div>
        <button @click="filter('dates')" class="btn">Filtrar</button>
      </div>
    </div>
    <!--End Filter-->

    <div style="visibility: hidden">
      <div id="labels-container">
        <div
          v-for="(label, index) in labels"
          :key="label.tracking"
          class="shipping-label"
        >

          <div class="label-header">
            <span class="brand">Enwam Courier</span>
            <span class="client">{{ label.clientName }}</span>
          </div>

          <div class="recipient-box">
            <h2>{{ label.name }}</h2>
            <p>{{ label.phone }}</p>
          </div>

          <div class="address-block">
            <p class="label-title">Dirección:</p>
            <p>{{ label.address }}</p>

            <p class="label-title">Distrito:</p>
            <p>{{ label.district.label }}</p>

            <p class="label-title">Referencia:</p>
            <p>{{ label.reference }}</p>
          </div>

          <div class="details-block">
            <p>Monto a cobrar: <strong>{{ label.totalToBeCollected }}</strong></p>
            <p>Entrega: <strong>{{ label.deadline }}</strong></p>
          </div>

          <svg class="barcode" :id="`barcode-${index}`"></svg>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db, Timestamp } from '@/firebase/firebaseConfig'
import moment from 'moment'

import JsBarcode from 'jsbarcode'
import printJS from 'print-js'
import LinkIcon from '../components/atoms/icons/LinkIcon.vue'

export default {
  name: 'History',
  components: { LinkIcon },
  data () {
    return {
      list: [],
      progress: false,
      showSearch: false,
      showFilter: false,
      filterData: {
        deadline: {
          start: new Date(),
          end: new Date(new Date().setDate(new Date().getDate() + 1))
        }
      },
      search: '',
      districts: [],
      currentDateFilter: 'today',
      labels: []
    }
  },
  computed: {
    filteredList () {
      return this.list.filter(o => {
        return o.fullName.toLowerCase().includes(this.search.toLowerCase())
      })
    },
    user () {
      return this.$store.state.user
    }
  },
  watch: {
    currentDateFilter (value) {
      this.filter(value)
    },
    async user (val) {
      if (val) {
        try {
          await this.getDistricts()
          await this.filter('today')
        } catch (e) {
          this.$toast.error('Error al cargar usuario', {
            duration: 6000
          })
        }
      }
    }
  },
  async created () {
    try {
      await this.$store.dispatch('setUser') // Set in store
    } catch (e) {
      this.$toast.error('Error al cargar datos', {
        duration: 6000
      })
    }
  },
  methods: {
    /**
     * Get districts from Firebase
     */
    async getDistricts () {
      const snap = await db.collection('districts').orderBy('sortOrder', 'asc').get()
      this.districts = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }))
    },
    /**
     * Filter
     * @param type
     * @returns {Promise<void>}
     */
    async filter (type) {
      try {
        this.showFilter = false
        this.list = []
        this.$store.dispatch('showProgress')
        // Set start date
        let startDate = new Date()
        let endDate = new Date()
        startDate.setHours(0)
        startDate.setMinutes(0)
        startDate.setSeconds(0)
        // Set end date
        endDate.setHours(23)
        endDate.setMinutes(59)
        endDate.setSeconds(0)

        let startTimes = null
        let endTimes = null

        if (type === 'today') {
          startTimes = Timestamp.fromDate(startDate)
          endTimes = Timestamp.fromDate(endDate)
        } else if (type === 'tomorrow') {
          startDate.setDate((new Date()).getDate() + 1)
          endDate.setDate((new Date()).getDate() + 1)
          startTimes = Timestamp.fromDate(startDate)
          endTimes = Timestamp.fromDate(endDate)
        } else if (type === 'dates') {
          startDate = new Date(this.filterData.deadline.start)
          startDate.setHours(0)
          startDate.setMinutes(0)
          startDate.setSeconds(0)

          endDate = new Date(this.filterData.deadline.end)
          endDate.setHours(23)
          endDate.setMinutes(59)
          endDate.setSeconds(0)

          startTimes = Timestamp.fromDate(startDate)
          endTimes = Timestamp.fromDate(endDate)
        }

        const querySnapshot = await db.collection('detail')
          .where('clientId', '==', this.user.client.id)
          .where('deadline', '>=', startTimes)
          .where('deadline', '<=', endTimes)
          .orderBy('deadline', 'asc')
          .get()

        querySnapshot.forEach((doc) => {
          const obj = {
            id: doc.id,
            ...doc.data(),
            pickUpDate: doc.data().pickUpDate ? doc.data().pickUpDate.toDate() : null,
            deadline: doc.data().pickUpDate ? doc.data().deadline.toDate() : null
          }

          obj.pickUpDate = moment(obj.pickUpDate).format('YYYY-MM-DD')
          obj.deadline = moment(obj.deadline).format('YYYY-MM-DD')

          this.list.push({
            ...obj
          })
        })
      } catch (e) {
        console.log(e)
        this.$toast.error('Error al filtrar', {
          duration: 6000
        })
      } finally {
        this.$store.dispatch('hideProgress')
      }
    },
    /**
     * Exports to excel
     */
    async exportToExcel () {
      try {
        const _ = require('lodash')
        const list = _.cloneDeep(this.list)
        list.forEach(o => {
          o.type = o.type.label
          o.district = o.district.label
          o.pickupAddress = o.pickupAddress.address
          o.statusText = this.getStatusText(o.status)
          o.shippingCost = (o.district?.price || 0) + (o.type?.price || 0)
          o.evidencia = o.dealer && o.dealer.deliveryImages && o.dealer.deliveryImages.length
            ? o.dealer.deliveryImages.join(', ')
            : (o.dealer && o.dealer.deliveryImage ? o.dealer.deliveryImage : '')
          o.dealerComments = o.dealer ? o.dealer.comments || '' : ''
          o.dealerName = o.dealer ? o.dealer.dealerName || '' : ''
        })
        import('@/vendor/Export2Excel').then(excel => {
          const headerVal = ['evidencia', 'correlative', 'statusText', 'pickUpDate', 'deadline', 'type', 'pickupAddress', 'address', 'reference', 'district', 'fullName', 'phone', 'shippingCost', 'product', 'quantity', 'totalToBeCollected', 'notes', 'dealerComments']
          const headerTitle = ['Evidencia', 'Cód. tracking', 'Estado', 'Fecha de recojo', 'Fecha de entrega', 'Tipo de servicio', 'Local de recojo', 'Dirección', 'Referencia', 'Distrito', 'Nombre de cliente', 'Teléfono', 'Costo de envío', 'Producto', 'Cantidad', 'Total a cobrar', 'Notas de entrega', 'Comentarios']
          const data = this.formatJson(headerVal, list)
          excel.export_json_to_excel({
            header: headerTitle,
            data,
            filename: 'Envíos Enwam',
            autoWidth: true,
            bookType: 'xlsx'
          })
        })
      } catch (e) {
        console.log(e)
      }
    },
    /**
     * Format json
     * @param filterVal
     * @param jsonData
     * @returns {*}
     */
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        return v[j]
      }))
    },
    // Generate barcodes in each SVG
    async generateBarcodes () {
      await this.$nextTick() // asegura que el DOM está listo
      this.labels.forEach((label, index) => {
        const selector = `barcode-${index}`
        const el = document.getElementById(selector)
        if (el) {
          JsBarcode(el, label.tracking, {
            format: 'CODE128',
            height: 50,
            width: 3,
            displayValue: true,
            fontSize: 24
          })
        }
      })
    },
    /**
     * Generate labels
     */
    generateLabels () {
      this.labels = []
      this.list.forEach((obj) => {
        this.labels.push(
          {
            name: obj.fullName,
            phone: obj.phone,
            address: obj.address,
            district: obj.district,
            totalToBeCollected: obj.totalToBeCollected,
            reference: obj.reference,
            tracking: obj.correlative,
            deadline: moment(obj.deadline).format('YYYY-MM-DD'),
            clientName: obj.client.name
          }
        )
      })
    },
    /**
     * Print labels
     */
    async printLabels () {
      this.generateLabels()
      await this.generateBarcodes()
      await this.replaceSVGWithImages()
      setTimeout(() => {
        printJS({
          printable: 'labels-container',
          type: 'html',
          scanStyles: false,
          style: `@page {
              size: 4.2in 6in;
              margin-top: 8px;
            }

           /* Contenedor general */
            .shipping-label {
              width: 4in;
              height: 5.8in;
              padding: 16px 20px; /* margen derecho corregido */
              box-sizing: border-box;
              font-family: Arial, sans-serif;
              border: 2px solid #000;
              page-break-after: always;
            }

            /* Header */
            .label-header {
              display: flex;
              justify-content: space-between;
              align-items: center;
              font-weight: bold;
              border-bottom: 2px solid #000;
              padding-bottom: 6px;
              margin-bottom: 10px;
            }

            .label-header .brand {
              font-size: 16px;
              text-transform: uppercase;
            }

            .label-header .client {
              font-size: 11px;
              opacity: 0.8;
            }

            /* Destinatario */
            .recipient-box {
              border: 2px solid #000;
              padding: 12px;
              margin-bottom: 12px;
            }

            .recipient-box h2 {
              font-size: 20px;
              margin: 0 0 4px 0;
              font-weight: bold;
            }

            .recipient-box p {
              font-size: 15px;
              margin: 0;
            }

            /* Dirección */
            .address-block {
              border-top: 1px dashed #555;
              border-bottom: 1px dashed #555;
              padding: 10px 0;
              margin-bottom: 12px;
              font-size: 15px;
            }

            .address-block p {
              margin: 3px 0;
            }

            /* Labels (nuevo) */
            .address-block .label-title {
              font-weight: bold;
              font-size: 13px;
              text-transform: uppercase;
              margin-bottom: 2px;
            }

            /* Detalles */
            .details-block {
              margin-bottom: 12px;
              font-size: 15px;
            }

            .details-block strong {
              font-size: 16px;
            }

            /* Barcode */
            .barcode {
              width: 100%;
              height: 80px;
              margin-top: 14px;
            }
        `
        })
      }, 1000)
    },
    /**
     * Barcode converter
     */
    svgToBase64 (svgEl) {
      const serializer = new XMLSerializer()
      const svgStr = serializer.serializeToString(svgEl)
      return 'data:image/svg+xml;base64,' + btoa(svgStr)
    },
    /**
     * Replace all SVG barcodes with <img> for printing
     */
    async replaceSVGWithImages () {
      await this.$nextTick() // wait for DOM

      this.labels.forEach((label, index) => {
        const svgEl = document.getElementById(`barcode-${index}`)
        if (svgEl) {
          const imgSrc = this.svgToBase64(svgEl)
          const imgEl = document.createElement('img')
          imgEl.src = imgSrc
          imgEl.style.width = svgEl.style.width || 'auto'
          imgEl.style.height = svgEl.style.height || 'auto'

          svgEl.parentNode.replaceChild(imgEl, svgEl)
        }
      })
    },
    /**
     * Get Status Text
     */
    getStatusText (status) {
      switch (status) {
        case 'hold': return 'Sin confirmar'
        case 'done': return 'Entregado'
        case 'confirmed': return 'Recogido'
        case 'canceled': return 'Anulado'
        case 'canceledWithCharge': return 'Anulado con cobro'
        case 'rejected': return 'Rechazado'
        case 'rejectedWithCharge': return 'Rechazado con cobro'
        case 'rescheduledWithoutCharge': return 'Reprogramado sin cobro'
        case 'rescheduledWithCharge': return 'Reprogramado con cobro'
      }
    }
  }
}
</script>
